import { createApi } from '@reduxjs/toolkit/query/react';
import customBaseQuery from '@/lib/customBaseQuery';

const settingsBaseUrl = '/api/settings';
export const settingsApi = createApi({
  reducerPath: 'settingsApi',
  baseQuery: customBaseQuery,
  tagTypes: ['Settings'],
  endpoints: (builder) => ({
    getSettings: builder.query<SettingsData[], SettingsParams>({
      query: (params) => ({
        url: settingsBaseUrl,
        params,
      }),
      providesTags: ['Settings'],
    }),
  }),
});

export const { useGetSettingsQuery } = settingsApi;
